module.exports = __webpack_public_path__ + "img/super-mario-bros.37b2d504.png";